import React from 'react'
import ShimmerEffect from '@/components/ui/shimmer'

/**
 * Loading frame for the bet pad docked in the list's column. Mirrors what PlaceBet draws
 * there — its own bordered panel, the market title, the buy/sell chips, then the form —
 * so the column shows the shape that is coming instead of going blank.
 *
 * The selected row shows it while its pad's chunk loads, or while a remount is putting
 * the pad back.
 */
const DockedPlaceBetSkeleton = () => (
  <ShimmerEffect className="w-full bg-surface-2 rounded-lg border border-solid border-Neutral-3">
    <div className="animate-pulse">
      {/* Title, on the chips' own left edge and 16px clear of them. */}
      <div className="px-5 pt-4 pb-4">
        <div className="h-4 w-3/4 rounded bg-surface-3" />
      </div>

      <div className="flex items-center gap-1 px-5">
        <div className="h-8 w-16 rounded-full bg-surface-3" />
        <div className="h-8 w-16 rounded-full bg-surface-3" />
      </div>

      <div className="space-y-4 p-5">
        <div className="flex gap-2">
          <div className="h-10 flex-1 rounded-lg bg-surface-3" />
          <div className="h-10 flex-1 rounded-lg bg-surface-3" />
        </div>
        <div className="h-12 rounded-lg bg-surface-3" />
        <div className="flex items-center justify-between">
          <div className="h-4 w-20 rounded bg-surface-3" />
          <div className="h-4 w-16 rounded bg-surface-3" />
        </div>
        <div className="h-12 rounded-lg bg-surface-3" />
      </div>
    </div>
  </ShimmerEffect>
)

export default DockedPlaceBetSkeleton
